import React from 'react'
import { connect } from "react-redux";
import { GetDepositAccountByAmount, SetDepositOldBank } from '$Deposits/store/actions/DepositAction'
import { GetParamsData } from '$Deposits/lib/LibCommonData'
import { LB_Submit } from '$Deposits/store/actions/DepositEvent'



class LB extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {
        const { LivechatClick } = GetParamsData()
        const {
            GetDepositAccountByAmount,
            DepositNextStep,
            DepositSuccessPage,
            DepositOldBank,
            SetDepositOldBank,
            TipsView,
            MoneyInput,
            BankSelect,
            SubmitBtn,
            NextStep,
            SuccessPage,
            OldBank,
            OldBankLine,
            UserBankSelect,
            BanksBankAccounts = [],
            BankNone,
        } = this.props
        const { isAutoAssign = false } = this.props.MethodsDetails?.setting || {}

        return (
            <>

                {
                    //没有银行卡
                    !DepositNextStep && !DepositSuccessPage && !DepositOldBank && (
                        BanksBankAccounts.length == 0 ? (
                            <BankNone LivechatClick={LivechatClick} methods={'LB'} onChange={() => { SetDepositOldBank(true) }} />
                        ) : (
                            <>
                                <MoneyInput />
                                {!isAutoAssign && <BankSelect />}
                                <UserBankSelect />
                                {/* <OldBankLine
                                    onChange={() => { SetDepositOldBank(true) }}
                                    msg={'Tôi đã gửi tiền vào tài khoản cũ'}
                                /> */}
                                <SubmitBtn
                                    OldBankLine={<OldBankLine
                                        onChange={() => { SetDepositOldBank(true) }}
                                        msg={'Tôi đã gửi tiền vào tài khoản cũ'}
                                    />}
                                    submitBtn={LB_Submit}
                                    onPress={() => { GetDepositAccountByAmount() }}
                                    submitBtnItem={'Tiếp Theo'}
                                />
                            </>
                        )
                    )
                }

                <>
                    {
                        //下一步
                        DepositNextStep &&
                        <NextStep />
                    }
                    {
                        //存款成功
                        DepositSuccessPage &&
                        <SuccessPage />
                    }
                </>

                {
                    DepositOldBank &&
                    <OldBank />
                }
            </>

        );
    }
}

const mapStateToProps = state => ({
    BanksBankAccounts: state.BanksBankAccounts,
    DepositNextStep: state.DepositNextStep,
    DepositSuccessPage: state.DepositSuccessPage,
    DepositOldBank: state.DepositOldBank,
    MethodsDetails: state.MethodsDetails,
});
const mapDispatchToProps = {
    GetDepositAccountByAmount: (data = false) => GetDepositAccountByAmount(data),
    SetDepositOldBank: (data = false) => SetDepositOldBank(data),
};
export default connect(mapStateToProps, mapDispatchToProps)(LB);


